export default __webpack_public_path__ + "static/media/jpg_bg_1.1df1199d.png";